import {connect} from 'react-redux';
import {Loader, modal, utils, authActions} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import OrderPage from "./OrderPage";
import PotvrzeniForm from "../../../forms/PotvrzeniForm";
import {withRouter} from "react-router";
import * as ciselnikActions from "../../../actions/ciselnikActions";
import * as subjektActions from "../../../actions/subjektActions";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import * as uzivatelActions from "../../../actions/uzivatelActions";
import * as opravneniActions from "../../../actions/opravneniActions";
import ObjednavkaApi from "../../../api/gen/cgo/ObjednavkaApi";
import ObjednavkyUrlFactory from "../../../api/ObjednavkyUrlFactory";
import {isEmailNotificationsEnabled, formatDate, isSmsNotificationsEnabled, timeStringToDate} from "../../../utils/utils";
import {withTranslation, WithTranslation} from "react-i18next";

const CURRENT_STEP = 5;

/**
 * Stránka procesu objednávky - Potvrzení objednávky.
 */
class PotvrzeniPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {loggedInUser, zakaznikData, dopravaData, platbaData} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            const userId = loggedInUser.data.id;
            this.props.dispatch(objednavkaActions.fetchDataZakazkaIfNeeded(userId));
            this.props.dispatch(objednavkaActions.fetchDataZakaznikIfNeeded(userId));
            this.props.dispatch(objednavkaActions.fetchDataDopravaIfNeeded(userId));
            this.props.dispatch(objednavkaActions.fetchDataPlatbaIfNeeded(userId));
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(userId));
            this.props.dispatch(ciselnikActions.fetchUkonyIfNeeded());
        }
        if (platbaData.fetched && !platbaData.isFetching && platbaData.data) {
            this.props.dispatch(ciselnikActions.fetchZpusobPlatbyIfNeeded(platbaData.data.zpusobPlatbaId));
        }
        if (zakaznikData.fetched && !zakaznikData.isFetching && zakaznikData.data && dopravaData.fetched && !dopravaData.isFetching && dopravaData.data) {
            if (dopravaData.data.naPobocku) {
                this.props.dispatch(ciselnikActions.fetchPobockaIfNeeded(dopravaData.data.pobockaId));
            }
        }
        if (dopravaData.fetched && !dopravaData.data.naPobocku && dopravaData.data.zpusobDopravaId && dopravaData.data.terminDopravaId) {
            this.props.dispatch(ciselnikActions.fetchTerminDopravyIfNeeded(dopravaData.data.zpusobDopravaId, dopravaData.data.terminDopravaId));
        }
    };

    render() {
        const {loggedInUser, aktivniSpolecnostId, pobockaDetail, zakazkaData, zakaznikData, dopravaData, platbaData,
            zpusobPlatbaDetail, terminDopravaDetail, ukonyList, authInfo, t} = this.props;

        if (!aktivniSpolecnostId.fetched
            || (!zakazkaData.fetched || zakazkaData.isFetching) || (!zakaznikData.fetched || zakaznikData.isFetching)
            || (!dopravaData.fetched || dopravaData.isFetching) || (!platbaData.fetched || platbaData.isFetching)
            || !zpusobPlatbaDetail.fetched
            || (dopravaData.data && !dopravaData.data.naPobocku && dopravaData.data.zpusobDopravaId && dopravaData.data.terminDopravaId && !terminDopravaDetail.fetched)
            || !ukonyList.fetched) {
            return <Loader />;
        }

        let pobocka;
        let adresa;
        let terminDoprava;
        if (dopravaData.data.naPobocku) {
            pobocka = pobockaDetail.data;
        } else {
            const {ulice, obec, psc, stat} = dopravaData.data;
            adresa = {ulice, obec, psc, stat};
            terminDoprava = terminDopravaDetail.data;
        }

        return <OrderPage title={t('pages.main.title')} subtitle={t('order.new')} currentStep={CURRENT_STEP}>
            <PotvrzeniForm
                onSubmit={data => {
                    // console.log("Zakázka", zakazkaData.data);
                    // console.log("Zákazník", zakaznikData.data);
                    // console.log("Doprava", dopravaData.data);
                    // console.log("Platba", platbaData.data);

                    const zakazka = zakazkaData.data;
                    const zakaznik = zakaznikData.data;
                    const doprava = dopravaData.data;
                    const platba = platbaData.data;

                    const datumVyzvednuti = doprava.naPobocku && doprava.datumVyzvednuti ? formatDate(doprava.datumVyzvednuti, null, "YYYY-MM-DD") : null;
                    const datumDoruceni = !doprava.naPobocku && doprava.datumDoruceni ? formatDate(doprava.datumDoruceni, null, "YYYY-MM-DD") : null;
                    const casVyzvednuti = doprava.naPobocku ? timeStringToDate(doprava.casVyzvednuti) : null;

                    const emailNotificationsEnabled = isEmailNotificationsEnabled(authInfo);
                    const smsNotificationsEnabled = isSmsNotificationsEnabled(authInfo);

                    const objednavkaVO = {
                        pobockaId: doprava.naPobocku ? doprava.pobockaId : null,
                        spolecnostId: zakaznik.uzivatelASpolecnost ? zakaznik.uzivatelASpolecnost.spolecnostId : aktivniSpolecnostId.data ? aktivniSpolecnostId.data : null,
                        kartaId: zakaznik.karta ? zakaznik.karta.id : null,
                        adresaId: doprava.adresa ? doprava.adresa.id : null,
                        ulice: doprava.ulice,
                        obec: doprava.obec,
                        psc: doprava.psc,
                        stat: doprava.stat,
                        email: zakaznik.email,
                        telefon: zakaznik.telefon,
                        zpusobPlatbaId: platba.zpusobPlatbaId ? parseInt(platba.zpusobPlatbaId) : null,
                        zpusobDopravaId: doprava.zpusobDopravaId ? parseInt(doprava.zpusobDopravaId) : null,
                        terminDopravaId: !doprava.naPobocku && doprava.terminDopravaId ? parseInt(doprava.terminDopravaId) : null,
                        pocetVyhotoveni: zakazka.pocetVyhotoveni ? parseInt(zakazka.pocetVyhotoveni) : null,
                        razitkovat: !!zakazka.razitkovat,
                        razCiselnaRada: zakazka.ciselnaRada ? zakazka.ciselnaRada : null,
                        poznamka: zakazka.poznamka ? zakazka.poznamka : null,
                        naklStredObjednavka: zakaznik.naklStredObjednavka
                            ? zakaznik.naklStredObjednavka.nazevStredisko
                                ? zakaznik.naklStredObjednavka.nazevStredisko
                                : zakaznik.naklStredObjednavka
                            : null,
                        datumVyzvednuti: datumVyzvednuti,
                        casVyzvednuti: doprava.naPobocku ? casVyzvednuti : null,
                        datumDoruceni: datumDoruceni,
                        cenovaNabidka: !!platba.cenovaNabidka,
                        objednavkaSouborList: zakazka.fileMetas ? zakazka.fileMetas.map(fileMeta => {
                            return {
                                kodSouborTmp: fileMeta.code,
                                nazevSoubor: fileMeta.name,
                                podslozky: fileMeta.podslozky,
                                objednavkaSouborAtributList: Object.keys(fileMeta.attributes).map(key => {
                                    return {souborAtributHodnId: fileMeta.attributes[key].id}
                                })
                            }
                        }) : null,
                        objednavkaUkonList: Object.keys(zakazka).filter(key => key.startsWith("ukon_")).map(key => {
                            return {id: zakazka[key].ukonId, ukonPolozkaId: zakazka[key].id}
                        }),
                        notifikaceEmail: emailNotificationsEnabled && zakaznik.notifikaceEmail,
                        notifikaceSms: smsNotificationsEnabled && zakaznik.notifikaceSms,
                        uzivatelObjednalId: zakaznik.uzivatelASpolecnost ? zakaznik.uzivatelASpolecnost.uzivatelId : loggedInUser.data.id,
                    };
                    this.props.dispatch(modal.ModalActions.showAsyncWaiting(
                        t('please_wait'),
                        <Loader>Probíhá uložení souborů ke zpracování...</Loader>,
                        ObjednavkaApi.createObjednavka(objednavkaVO), (result) => {
                            this.props.dispatch(objednavkaActions.clearRozpracovanaObjednavka(loggedInUser.data.id));
                            this.props.dispatch(objednavkaActions.invalidateObjednavky());
                            this.props.dispatch(objednavkaActions.invalidateObjednavkyPrehled());
                            this.props.dispatch(objednavkaActions.invalidateObjednavkyCountStats());
                            this.props.history.push(ObjednavkyUrlFactory.objednavkaConfirm(result.objednavkaVO.id));
                        }
                    ));
                }}
                nahraneSouboryList={zakazkaData.data.fileMetas && zakazkaData.data.fileMetas || []}
                zakazkaData={{
                    ...zakazkaData.data,
                    objednavkaUkonList: Object.keys(zakazkaData.data).filter(key => key.startsWith("ukon_")).map(key => {
                        return {
                            ...zakazkaData.data[key],
                            nazevUkon: ukonyList.rows.filter(item => item.id === zakazkaData.data[key].ukonId)[0].nazevUkon
                        }
                    })
                }}
                zakaznikData={zakaznikData.data}
                dopravaData={dopravaData.data}
                platbaData={platbaData.data}
                zpusobPlatba={zpusobPlatbaDetail.data}
                pobocka={pobocka}
                adresa={adresa}
                terminDoprava={terminDoprava}
            />
        </OrderPage>
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        pobockaDetail: utils.storeFromArea(state, ciselnikActions.POBOCKA_AREA),
        uzivatelAdresaDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_ADRESA_AREA),
        spolecnostAdresaDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_ADRESA_AREA),
        zakazkaData: utils.storeFromArea(state, objednavkaActions.ZAKAZKA_DETAIL_AREA),
        zakaznikData: utils.storeFromArea(state, objednavkaActions.ZAKAZNIK_DETAIL_AREA),
        dopravaData: utils.storeFromArea(state, objednavkaActions.DOPRAVA_DETAIL_AREA),
        platbaData: utils.storeFromArea(state, objednavkaActions.PLATBA_DETAIL_AREA),
        zpusobPlatbaDetail: utils.storeFromArea(state, ciselnikActions.ZPUSOB_PLATBY_AREA),
        terminDopravaDetail: utils.storeFromArea(state, ciselnikActions.TERMIN_DOPRAVY_AREA),
        ukonyList: utils.storeFromArea(state, ciselnikActions.UKONY_LIST_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(PotvrzeniPage)));

